import React, { ReactElement } from 'react'

import { NextPage } from 'app/types/decalarations/next'

import MainLayout from '~/components/layouts/MainLayout'
import AuthTrianglesContainer from '~/components/layouts/TrianglesContainer'
import SignUpPersonalView from '~/views/Auth/SignUpPersonalView'

const PersonalAccountSignUpPage: NextPage = () => <SignUpPersonalView />

PersonalAccountSignUpPage.getLayout = (page: ReactElement) => (
  <MainLayout>
    <AuthTrianglesContainer>{page}</AuthTrianglesContainer>
  </MainLayout>
)

PersonalAccountSignUpPage.getMeta = (intl) => ({
  title: intl.formatMessage({
    defaultMessage: 'Personal Account Sign Up'
  }),
  description: intl.formatMessage({
    defaultMessage: 'Personal Account Sign Up description'
  })
})

export default PersonalAccountSignUpPage
